export default __webpack_public_path__ + "static/biege-bg-7ec6df3013bf0fdbf2f9469f205dd909.png";